import React, {useState} from 'react';
import moment from 'moment';
import styles from './venda-selecionada.scss';

const VendaSelecionada = (props) => {
    const {venda} = props;

    if(venda && venda !== null){
        return <div className={styles.wrapper}>
                    <span className={styles.tipo}>
                     {venda.tipo}
                    </span>
                    <span className={styles.id}>
                        #{venda.numeroVenda}
                    </span>
                    <span className={styles.cliente}>
                        {(venda.cliente || 'Avulso')}
                    </span>
                    <span className={styles.data}>
                        {moment(venda.data).format('DD-MM-YYYY HH:mm:ss')}
                    </span>
                </div>

    } else {
        return <></>
    }
}

export {VendaSelecionada};